const locale = {
	hours: "Hours",
	minutes: "Minutes",
	save: "Save",
};

export default locale;
